// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_style_tabs__253Zb","chips":"tabs_style_chips__-_Cin","selectors":"tabs_style_selectors__HTfnx","fill":"tabs_style_fill__3bFzt","tab":"tabs_style_tab__35Cwi"};